import React, { useContext } from 'react';

import DiscoveryContextV2 from '@/contexts/discoveryContext/contextV2';
import { FilterButton } from '../../FilterButton';
import ClearFilterButton from '../ClearFilterButton';
import { bold } from './styles.module.css';

const CovidValueComponent = ({ modalOpen, clearFilter, ...props }) => {
  const {
    filters: {
      covid: { covidOnly },
    },
  } = useContext(DiscoveryContextV2);

  const isActive = !!covidOnly;

  const label = isActive ? 'C-19 Planned Only' : 'C-19 Races';

  return (
    <FilterButton active={isActive || modalOpen} {...props}>
      <span className={isActive ? bold : undefined}>{label}</span>
      {isActive && <ClearFilterButton onClick={clearFilter} />}
    </FilterButton>
  );
};

export default CovidValueComponent;
